import type { ComponentType } from 'react';
import FitbitMetricIcon from '../../fitbit/metrics/FitbitMetricIcon';
import FitbitMeasurementGuide from '../../fitbit/metrics/FitbitMeasurementGuide';
import UltrahumanMetricIcon from '../../ultrahuman/metrics/UltrahumanMetricIcon';
import UltrahumanMeasurementGuide from '../../ultrahuman/metrics/UltrahumanMeasurementGuide';
import type { MetricInput, MetricProviderId } from './types';

export const deviceMetricViews: Record<MetricProviderId, {
  Icon: ComponentType<{ metric: MetricInput }>;
  Guide: ComponentType<{ compact?: boolean }>;
}> = {
  fitbit: { Icon: FitbitMetricIcon, Guide: FitbitMeasurementGuide },
  ultrahuman: { Icon: UltrahumanMetricIcon, Guide: UltrahumanMeasurementGuide },
};
